import { CompanyStatus } from '@/graphql';

export const companyStatus: { [K in CompanyStatus]: string } = {
  [CompanyStatus.NotReady]: 'Nicht Bereit',
  [CompanyStatus.Usable]: 'Verwendbar',
  [CompanyStatus.InUse]: 'In Verwendung',
};

export default companyStatus;
